import React, { useState, useEffect, useContext, useRef } from 'react'
import ReadMoreReact from 'read-more-react'
import ImageGallery from 'react-image-gallery'
import Toaster from '../../Component/Toaster'
import FavouriteCheckbox from '../../Product/components/atoms/FavoriteCheckbox'
import { Link, useHistory, useParams } from 'react-router-dom'
import moment from 'moment-timezone'
import ReactPlayer from 'react-player'
import Bidhistory from '../../Component/Bidhistory'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useMediaQuery } from 'react-responsive'
import BuyerContext from '../../Product/context/buyer/buyerContext'
import AuthContext from '../../Product/context/auth/authContext'
import CartContext from '../../Product/context/cart/cartContext'
import ProductContext from '../../Product/context/product/productContext'
import AlertContext from '../../Product/context/alert/alertContext'
import StripeCardContext from '../../Product/context/stripe/card/cardContext'

import {
    currencyFormat,
    handleRedirectInternal,
    removeHTMLTags,
    mapData,
    getAdsImage,
} from '../../Product/common/components'
import Bidding from '../../Product/components/molecules/Bidding/BiddingItem'
import Biddingforwardandreverse from '../../Product/components/molecules/Bidding/biddingforwardandreverse'
import Timer from '../../Product/common/timer'
import {
    messageHandlerSingle,
    make_an_offer_update_socket,
    qtyHandleBuynowsingle,
    reverse_auction_item,
} from '../../Product/common/socketHandler'
import { socket, socketAuction } from '../../Product/common/socket'

import './slider.css'
import { Box, Button, Drawer, Tooltip } from '@material-ui/core'
import Facebook from '../../utils/CommonFunctionality/Share/Facebook'
import Whatsapp from '../../utils/CommonFunctionality/Share/Whatsapp'
import Twitter from '../../utils/CommonFunctionality/Share/Twitter'
import Email from '../../utils/CommonFunctionality/Share/Email'
import Pinterest from '../../utils/CommonFunctionality/Share/Pinterest'
import Loaders from '../../Product/components/molecules/Loaders'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import SecondaryButton from '../../Product/components/atoms/SecondaryButton'
import BidStatus from '../../Product/components/molecules/Bidding/BidStatus'
import publicIp from 'public-ip'
import MessagePlugin from '../../utils/CommonFunctionality/MessagePlugin'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import ReactImageMagnify from 'react-image-magnify'
import axios from 'axios'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Qtyinput from '../../Product/common/Qtyinputcard'
import MagnifyImageGallery from '../MagnifyImageGallery'
import Copy from '../../utils/CommonFunctionality/Share/Copy'
import Popup from '../../Product/components/organisms/Popup'

const SlidePanel = ({
    type,
    selectedLot,
    handleClose,
    viewPage,
    getAllProducts,
    from,
    audio,
    isRRThemeSlidePanel,
    enableZoomOnHover,
    is_registered,
    private_auction,
}) => {
    const buyerContext = useContext(BuyerContext)
    const cartContext = useContext(CartContext)
    const alertContext = useContext(AlertContext)
    const isDesktop = useMediaQuery({
        query: '(min-width: 991px)',
    })
    const authContext = useContext(AuthContext)
    const { setAlert } = alertContext
    const { get_all_card_details, get_skyflow_cards } = useContext(StripeCardContext)
    const { insertProductView, insert_make_proposels } = useContext(ProductContext)
    const hawaiiBodyClass = global?.storeConfigration?.bodyClass?.value === 'hawaii'
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const { user, isAuthenticated } = authContext
    const {
        buyer_allproducts,
        getAllBuyerProducts,
        product_view,
        getViewProduct,
        get_ship_station_amount,
        shipping_rate_calculation,
        clear_ship_station_amount,
    } = buyerContext
    const { addToCart, buyer_cartitems, getUserCart, removeFromCart, responseStatus } = cartContext
    const { id } = useParams()
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const [historyData, setHistoryData] = useState({})
    const [loading, setLoading] = useState(true)
    const [disabled, setDisabled] = useState(false)
    const [showTooltip, setShowTooltip] = useState(false)
    const [showToolTipCondition, setShowToolTipCondition] = useState(false)
    const [cards, setCards] = useState([])
    const [selectedProductImage, setSelectedProductImage] = useState([])
    const [productVideos, setProductVideos] = useState([])
    const [selectedProduct, setSelectedProduct] = useState({})
    const [isBidLoading, setBidLoading] = useState(false)
    const [upcomming, setUpcomming] = useState(false)
    const [shipping_amount, setShipping_amount] = useState(0)
    const [homeDepot, setHomeDepot] = useState({
        price: 0,
        date: '',
        product_url: '',
    })
    const [retailerInfo, setRetailerInfo] = useState({
        retailer_name: '',
        price: 0,
        date: '',
        product_url: '',
    })
    const [ASIN, setASIN] = useState({
        price: 0,
        date: '',
        product_url: '',
    })
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })
    let history = useHistory()
    const oneYear = new Date().setFullYear(new Date().getFullYear() + 1)
    const insertLotCount = async () => {
        // const ip = await publicIp.v4()
        if (selectedLot !== null) {
            insertProductView({ project_id: product_view?.results?.id, user_id: '124.123.104.221' })
        }
    }
    const [audio_loc] = useState(
        global.storeConfigration?.bidding_sound?.value == 1 && audio
            ? audio
            : global.storeConfigration?.bidding_sound?.value == 1
            ? new Audio('/audio/ding.mp3')
            : '',
    )
    const jamesClTheme = global?.storeConfigration?.bodyClass?.value == 'jamesCL'
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    function removeTagParam(url) {
        try {
            const parsedUrl = new URL(url)

            // Remove 'tag' query param if present
            parsedUrl.searchParams.delete('tag')

            // Also remove malformed or encoded 'tag' params (e.g. %2Ftag)
            for (const [key, value] of parsedUrl.searchParams.entries()) {
                if (decodeURIComponent(key).toLowerCase().includes('tag')) {
                    parsedUrl.searchParams.delete(key)
                }
            }
            return parsedUrl.toString()
        } catch (err) {
            console.error('Invalid URL:', url)
            return url // fallback if parsing fails
        }
    }

    const handleCloseAndClean = () => {
        setHomeDepot({
            price: 0,
            date: '',
            product_url: '',
        })
        setRetailerInfo({
            retailer_name: '',
            price: 0,
            date: '',
            product_url: '',
        })
        setASIN({
            price: 0,
            date: '',
            product_url: '',
        })
    }
    useEffect(() => {
        handleCloseAndClean()
        if (selectedLot) {
            setLoading(true)
            getViewProduct({
                product_id: selectedLot,
                bundle_info: global?.storeConfigration?.pallet_auction?.value == 1 ? 1 : undefined,
            })
        } else if (id) {
            setLoading(true)
            getViewProduct({
                product_id: id,
                bundle_info: global?.storeConfigration?.pallet_auction?.value == 1 ? 1 : undefined,
            })
        }
    }, [selectedLot, id])

    useEffect(() => {
        setLoading(true)
        if (
            product_view.results &&
            (selectedLot
                ? selectedLot && product_view.results?.id == selectedLot
                : product_view.results?.id == id)
        ) {
            setSelectedProduct({
                ...product_view.biddetails,
                ...product_view.results,
                incrementamt: product_view.incrementamt,
            })
            if (product_view?.attachments.length) {
                product_view?.attachments.forEach(function (data) {
                    data['original'] =
                        product_view.results?.store_id === 0
                            ? process.env.REACT_APP_BASE_URL + 'uploads/product/' + data.src
                            : process.env.REACT_APP_PRODUCT_IMAGE_URL + data.src
                    data['thumbnail'] = `${
                        product_view.results?.store_id === 0
                            ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                            : process.env.REACT_APP_PRODUCT_IMAGE_URL
                    }${global.storeConfigration?.image_compression?.value == 1 ? 'thumb_' : ''}${
                        data.src
                    }`
                })
                setSelectedProductImage(product_view.attachments)
            } else {
                setSelectedProductImage([
                    {
                        original: global?.storeDetails?.logoValue,
                        thumbnail: global?.storeDetails?.logoValue,
                    },
                ])
            }
            if (`${product_view?.results?.videos}`.trim()) {
                let temp_vid = []
                product_view?.results?.videos?.split(',')?.forEach(function (data) {
                    temp_vid.push(
                        data.includes('http')
                            ? data
                            : `${process.env.REACT_APP_BASE_URL + 'uploads/' + data}`,
                    )
                    // console.log(data, '++++++++++++++++++++')
                })
                // console.log(temp_vid)
                setProductVideos(temp_vid)
            }
            if (parseInt(product_view.results.buynow) === 1) {
                getUserCart()
            }
            setShipping_amount(0)
            setTimeout(() => {
                setLoading(false)
            }, 1000)
            insertLotCount()
        }
    }, [product_view.results])
    const renderVideo = (item) => {
        return (
            <div>
                <ReactPlayer
                    width="100%"
                    height="500px"
                    light={false}
                    controls={true}
                    url={item.embedUrl}
                />
            </div>
        )
    }
    useEffect(() => {
        let videoArr = []
        if (productVideos?.length) {
            videoArr = productVideos.map((val) => ({
                original: val,
                thumbnail: '/assets/images/videoCamera.png',
                embedUrl: val,
                renderItem: renderVideo.bind(this),
            }))
            // console.log(videoArr, 'videoArr')
        }
        product_view?.attachments?.length
            ? setSelectedProductImage([...selectedProductImage?.flat(), ...videoArr])
            : setSelectedProductImage([...videoArr])
    }, [productVideos])

    useEffect(() => {
        if (buyer_cartitems.results) {
            if (selectedLot) {
                let position = _.findIndex(buyer_cartitems.results, {
                    project_id: parseInt(selectedLot),
                })
                position === -1 ? setDisabled(false) : setDisabled(true)
            }
        }
    }, [buyer_cartitems.results, selectedLot])

    const handleClick = async (e) => {
        if (global?.storeConfigration?.guest_user_login?.value) {
            if (
                buyer_cartitems.results.find(
                    (val) => parseInt(val.product_id) === parseInt(selectedProduct.id),
                )
            ) {
                removeFromCart({ id: selectedProduct.id })
            } else {
                addToCart({ id: selectedProduct.id, qty: selectedProduct.qty })
                setDisabled(true)
            }
        } else {
            if (!cards.length && global?.storeConfigration?.credit_card_no_need?.value != 1) {
                setAlert('Add a card to buy!', 'error')
                return handleRedirectInternal(history, 'dashboard/cards')
            }
            if (
                buyer_cartitems.results.find(
                    (val) => parseInt(val.product_id) === parseInt(selectedProduct.id),
                )
            ) {
                removeFromCart({ id: selectedProduct.id })
            } else {
                addToCart({ id: selectedProduct.id, qty: selectedProduct.qty })
                setDisabled(true)
            }
        }
    }
    useEffect(() => {
        if (global.storeConfigration?.skyflow_integration?.value == 1) {
            if (get_skyflow_cards) {
                setCards(get_skyflow_cards)
            }
        } else {
            if (get_all_card_details) {
                setCards(get_all_card_details.records)
            }
        }
    }, [get_all_card_details, get_skyflow_cards])
    // useEffect(() => {
    //     if (responseStatus) {
    //         if (responseStatus.from === 'addToCart') {
    //             if (responseStatus.status === 'success') {
    //                 getUserCart()
    //             }
    //         }
    //     }
    // }, [responseStatus])

    // DO NOT ADD THIS CODE BACK. WE DO NOT WANT TO CALL THE ASIN SEARCH API ON THE FRONT END.
    // useEffect(() => {
    //     if (selectedProduct) {
    //         if (selectedProduct.hd_product_id) {
    //             const getHomedepot = async () => {
    //                 let base = process.env.REACT_APP_AUCTION_URL.replace('/api/', '')
    //                 const res = await axios.get(
    //                     `${base}/product/home_depot/${selectedProduct?.hd_product_id}?user_id=${selectedProduct?.user_id}&site_id=${global.storeDetails?.site_id}`,
    //                 )
    //                 if (res.data.success) {
    //                     setHomeDepot({
    //                         price: res.data.body.product_results.price,
    //                         date: moment(res.data.body.created_at).format('MMM Do YYYY'),
    //                         product_url: res.data.body.product_results.link,
    //                     })
    //                 }
    //             }

    //             getHomedepot()
    //         } else {
    //             setHomeDepot({
    //                 price: 0,
    //                 date: '',
    //                 product_url: '',
    //             })
    //         }
    //         if (selectedProduct.asin_no) {
    //             const getASIN = async () => {
    //                 var requestOptions = {
    //                     method: 'GET',
    //                     redirect: 'follow',
    //                 }

    //                 fetch(
    //                     `https://api.asinscope.com/products/lookup?key=${global?.asinscope_key}&asin=${selectedProduct.asin_no}`,
    //                     requestOptions,
    //                 )
    //                     .then((response) => response.text())
    //                     .then((result) => {
    //                         setASIN({
    //                             price: JSON.parse(result).items[0]?.lowestNewPrice,
    //                             product_url: `https://www.amazon.com/dp/${selectedProduct.asin_no}?%2Ftag=auction0f2-20&th=1`,
    //                         })
    //                     })
    //                     .catch((error) => console.log('error', error))
    //             }
    //             getASIN()
    //         } else {
    //             setASIN({
    //                 price: 0,
    //                 date: '',
    //                 product_url: '',
    //             })
    //         }
    //     }
    // }, [selectedProduct])

    useEffect(() => {
        if (selectedProduct) {
            if (
                selectedProduct.hd_product_id &&
                selectedProduct.mprice &&
                selectedProduct.retailer_link
            ) {
                setHomeDepot({
                    price: selectedProduct.mprice,
                    date: '',
                    product_url:
                        jamesClTheme &&
                        parseInt(global?.storeConfigration?.asin_auction_tag?.value) == 0
                            ? removeTagParam(selectedProduct?.retailer_link)
                            : selectedProduct.retailer_link,
                })
            } else {
                setHomeDepot({
                    price: 0,
                    date: '',
                    product_url: '',
                })
            }
            if (
                selectedProduct.retailer_name &&
                selectedProduct.mprice &&
                selectedProduct.retailer_link
            ) {
                setRetailerInfo({
                    price: selectedProduct.mprice,
                    product_url:
                        jamesClTheme &&
                        parseInt(global?.storeConfigration?.asin_auction_tag?.value) == 0
                            ? removeTagParam(selectedProduct?.retailer_link)
                            : selectedProduct.retailer_link,
                    retailer_name: selectedProduct.retailer_name,
                    date: '',
                })
            } else {
                setRetailerInfo({
                    retailer_name: '',
                    price: 0,
                    date: '',
                    product_url: '',
                })
            }
            if (
                selectedProduct.asin_no &&
                selectedProduct.mprice &&
                selectedProduct.retailer_link
            ) {
                setASIN({
                    price: selectedProduct.mprice,
                    product_url:
                        jamesClTheme &&
                        parseInt(global?.storeConfigration?.asin_auction_tag?.value) == 0
                            ? removeTagParam(selectedProduct?.retailer_link)
                            : selectedProduct.retailer_link,
                })
            } else {
                setASIN({
                    price: 0,
                    date: '',
                    product_url: '',
                })
            }
        }
    }, [selectedProduct])
    const viewProductRef = useRef(selectedProduct)
    const userRef = useRef(user)

    // Sets product and user refrences on page load
    useEffect(() => {
        viewProductRef.current = selectedProduct
        userRef.current = user
    })

    const handler = (message, type) => {
        messageHandlerSingle(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setSelectedProduct,
            type,
            setBidLoading,
        )
    }

    const validationmake_formik = Yup.object({
        proposed_amount: Yup.number()
            .positive('Enter Valid amount')
            .integer('Enter Valid amount')
            .typeError('Enter Valid amount')
            .min(1, `Enter Valid amount`)
            .test('is-decimal', 'Cannot be a decimal', (value) =>
                value ? typeof value === 'number' && value % 1 === 0 : true,
            )
            .required('Enter Valid amount'),
    })

    const make_formik = useFormik({
        initialValues: {
            proposed_amount: '',
            project_id: '',
            user_id: '',
            seller_id: '',
            status: '',
        },
        validationSchema: validationmake_formik,
        onSubmit: async (values) => {
            make_formik.values.project_id = selectedProduct.id
            make_formik.values.user_id = user.id
            make_formik.values.seller_id = selectedProduct.user_id
            make_formik.values.status = 'Pending'
            insert_make_proposels(values)
            make_formik.values.proposed_amount = ''
        },
    })

    var make_an_offer = [
        {
            label: 'Make Offer',
            placeholder: 'Enter Price',
            type: 'number',
            class: 'col-sm-6 col-12 makeMyOffer',
            name: 'proposed_amount',
            formik: make_formik,
        },
    ]

    const make_an_offer_update_new = (message, type) => {
        make_an_offer_update_socket(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setSelectedProduct,
            type,
        )
    }

    const qtyupdatebuynow = (message, type) => {
        qtyHandleBuynowsingle(
            message,
            viewProductRef.current,
            userRef.current,
            setSelectedProduct,
            type,
        )
    }

    const multiseller_handler = (message, type) => {
        if (parseInt(viewProductRef.current.content_head5) == 0) {
            messageHandlerSingle(
                message,
                viewProductRef.current,
                userRef.current,
                setAlert,
                setSelectedProduct,
                type,
            )
        } else {
            if (message.type == 'reverse_auction' && message.status == 'success') {
                reverse_auction_item(
                    message,
                    viewProductRef.current,
                    userRef.current,
                    setAlert,
                    setSelectedProduct,
                    'single',
                )
            }
        }
    }

    const DownloadManifest = (bundle_id) => {
        return axios
            .get(`${process.env.REACT_APP_URL}getbundlelotsinfo`, {
                params: { bundle_id: bundle_id },
                responseType: 'blob',
            })
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `Pallet_${bundle_id}.csv`)
                document.body.appendChild(link)
                link.click()
                link.remove()
            })
            .catch(function (error) {
                console.error('Error downloading the file:', error)
            })
    }

    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            data.id = data.pid

            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            if (global.pluginConfiguration?.reverse_auction?.enable) {
                multiseller_handler(data, 'bidAddtime')
            } else {
                handler(data, 'bidAddtime')
            }
        })

        socket.on('cancelbidemitted', (data) => {
            handler(data, 'cancelbidemitted')
        })

        socketAuction.on('realclosedupdates', (data) => {
            data.id = data.pid

            handler(data, 'realclosedupdates')
        })
        socketAuction.on('bidAddtime', (data) => {
            if (global.pluginConfiguration?.reverse_auction?.enable) {
                multiseller_handler(data, 'bidAddtime')
            } else {
                handler(data, 'bidAddtime')
            }
        })
        socket.on('make_an_offer_update', (data) => {
            make_an_offer_update_new(data, 'make_an_offer')
        })
        socket.on('real_close_update_buynow', (data) => {
            qtyupdatebuynow(data, 'qtyHandleBuynowsingl')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                data.id = data.pid

                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                if (global.pluginConfiguration?.reverse_auction?.enable) {
                    multiseller_handler(data, 'bidAddtime')
                } else {
                    handler(data, 'bidAddtime')
                }
            })

            socket.off('cancelbidemitted', (data) => {
                handler(data, 'cancelbidemitted')
            })

            socketAuction.off('realclosedupdates', (data) => {
                data.id = data.pid

                handler(data, 'realclosedupdates')
            })
            socketAuction.off('bidAddtime', (data) => {
                if (global.pluginConfiguration?.reverse_auction?.enable) {
                    multiseller_handler(data, 'bidAddtime')
                } else {
                    handler(data, 'bidAddtime')
                }
            })
            socket.off('make_an_offer_update', (data) => {
                make_an_offer_update_new(data, 'make_an_offer')
            })
            socket.off('real_close_update_buynow', (data) => {
                qtyupdatebuynow(data, 'qtyHandleBuynowsingl')
            })
        }
    }, [])

    const sliderRef = useRef(null)
    const imgRef = useRef([])
    const [rotateValue, setRotateValue] = useState(0)
    // console.log(selectedProductImage, 'selectedProductImage')
    const RenderImage = () => {
        return (
            <img
                src={selectedProductImage[sliderRef?.current?.getCurrentIndex()]?.original}
                className="checkRotate"
                id={`imgRef_${sliderRef?.current?.getCurrentIndex()}`}
                onError={(e) => (e.target.src = `${global?.storeDetails?.logoValue}`)}
            />
        )
    }

    const rotateImage = (index) => {
        let newValue = rotateValue + 90
        setRotateValue(newValue)

        if (newValue >= 450) {
            setRotateValue(0)
        } else {
            setRotateValue(newValue)
        }
        document.getElementsByClassName('checkRotate')[
            sliderRef?.current?.getCurrentIndex()
        ].style.transform = `rotate(${rotateValue}deg)`
    }
    // const RenderImageZoom = () => {
    //     return (
    //         <>
    //             <Button onClick={rotateImage} className="rotateImage">
    //                 <span className="material-icons">rotate_right</span>
    //             </Button>
    //         </>
    //     )
    // }

    const RenderImageZoom = () => {
        return (
            <>
                <ReactImageMagnify
                    {...{
                        smallImage: {
                            alt: '',
                            isFluidWidth: true,
                            src: selectedProductImage[sliderRef?.current?.getCurrentIndex()]
                                ?.original,
                            enlargedImageClassName: 'enlargedImage',
                        },
                        largeImage: {
                            src: selectedProductImage[sliderRef?.current?.getCurrentIndex()]
                                ?.original,
                            width: 800,
                            height: 800,
                        },
                        className: 'hoverZoom',
                        enlargedImagePosition: 'over',
                        isHintEnabled: false,
                        // enlargedImageContainerClassName: 'customZoom',
                        enlargedImageStyle: { objectFit: 'cover' },
                    }}
                />
            </>
        )
    }

    const calculate_shipstation_amount = () => {
        var calculation_data = {
            weight: selectedProduct.weight,
            height: selectedProduct.height,
            length: selectedProduct.length,
            width: selectedProduct.width,
            toPostalCode: user.zip,
            fromPostalCode: selectedProduct.sell_zipcode ? selectedProduct.sell_zipcode : '60446',
            site_id: global.storeDetails?.site_id ? global.storeDetails.site_id : '',
            project_id: selectedProduct.id,
            toCountry: user.country,
        }
        get_ship_station_amount(calculation_data)
    }

    useEffect(() => {
        if (shipping_rate_calculation.message) {
            if (shipping_rate_calculation.message.shipping_status) {
                if (shipping_rate_calculation.message.shipping_status == 200) {
                    setShipping_amount(
                        shipping_rate_calculation.message.rate[0]?.shipmentCost
                            ? parseFloat(shipping_rate_calculation.message.rate[0].shipmentCost)
                            : '0',
                    )
                } else if (shipping_rate_calculation.message.shipping_status == 500) {
                    setAlert(
                        'Product dimensional or Zip Code incorrect.Please check your Zip Code or contact seller.',
                        'error',
                    )
                } else {
                    setAlert('Please Try Again Later!', 'error')
                }
            } else {
                setAlert('Please Try Again Later!', 'error')
            }
            clear_ship_station_amount()
        }
    }, [shipping_rate_calculation])

    const imageChangeInterval = global?.pluginConfiguration?.advertisement?.refresh_key * 60000 // Convert minutes to milliseconds

    const isMobile = useMediaQuery({
        query: '(max-width: 500px)',
    })

    const [prodAds, setProdAds] = useState({
        deskProdTop: '',
        deskProdMid: '',
        deskProdBottom: '',
        mobProdTop: '',
        mobProdMid: '',
        mobProdBottom: '',
    })

    const [activeProdAdsIndex, setActiveProdAdsIndex] = useState({
        deskProdTop: 0,
        deskProdMid: 0,
        deskProdBottom: 0,
        mobProdTop: 0,
        mobProdMid: 0,
        mobProdBottom: 0,
    })

    function updateRandomIndex(array) {
        const randomIndex = Math.floor(Math.random() * array.length)
        return randomIndex
    }

    useEffect(() => {
        setProdAds((prevAucAds) => ({
            deskProdTop: getAdsImage(1, 3, 1),
            deskProdMid: getAdsImage(1, 3, 2),
            deskProdBottom: getAdsImage(1, 3, 5),
            mobProdTop: getAdsImage(2, 3, 1),
            mobProdMid: getAdsImage(2, 3, 2),
            mobProdBottom: getAdsImage(2, 3, 5),
        }))
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveProdAdsIndex((prevActiveIndex) => ({
                deskProdTop: updateRandomIndex(prodAds?.deskProdTop),
                deskProdMid: updateRandomIndex(prodAds?.deskProdMid),
                deskProdBottom: updateRandomIndex(prodAds?.deskProdBottom),
                mobProdTop: updateRandomIndex(prodAds?.mobProdTop),
                mobProdMid: updateRandomIndex(prodAds?.mobProdMid),
                mobProdBottom: updateRandomIndex(prodAds?.mobProdBottom),
            }))
        }, imageChangeInterval)
        return () => clearInterval(interval)
    }, [prodAds])

    const [tipOpen, setTipOpen] = React.useState(false)
    const [prmtipOpen, setPrmTipOpen] = React.useState(false)
    const [pickUpPopup, setPickUpPopup] = useState(false)
    const togglePopup = () => {
        setPickUpPopup(!pickUpPopup)
    }
    const handlehoverPrmTioClose = () => {
        setPrmTipOpen(false)
    }
    const handlehoverPrmTioOpen = () => {
        setPrmTipOpen(true)
    }
    const handlehoverTioClose = () => {
        setTipOpen(false)
    }

    const handlehoverTioOpen = () => {
        setTipOpen(true)
    }
    const getDiscountPercentage = (retailPrice, buyNowPrice) => {
        if (!retailPrice || retailPrice <= 0) return 0
        const discount = ((retailPrice - buyNowPrice) / retailPrice) * 100
        return discount.toFixed(0)
    }
    const discount = getDiscountPercentage(selectedProduct?.mprice, selectedProduct?.bprice)
    const wdiscount = getDiscountPercentage(selectedProduct?.mprice, selectedProduct?.wprice)

    const RRThemeRender = (
        <>
            {loading ? (
                <div className="sliderLoader">
                    <Loaders name="product_view" isLoading={loading} loop={1} />
                </div>
            ) : (
                <>
                    {selectedProduct?.id ? (
                        <div
                            className="GFThemeBidSlider"
                            style={{
                                background: '#fff',
                                minHeight: '100vh',
                                padding: '20px 15px',
                            }}
                        >
                            <div className="RRQuickPreviewRightDrawer">
                                {isAuthenticated &&
                                global?.storeConfigration?.bid_box_bidding_message?.value != 1
                                    ? selectedProduct.auction
                                        ? type === 'buynow'
                                            ? null
                                            : selectedProduct?.bidtopstatus && (
                                                  <BidStatus
                                                      bidTopStatus={selectedProduct.bidtopstatus}
                                                  />
                                              )
                                        : null
                                    : null}
                                <div className="drawerHeader d-flex align-items-center justify-content-start">
                                    <span
                                        className="material-icons-outlined closeIco"
                                        onClick={() => {
                                            handleClose()
                                        }}
                                    >
                                        close
                                    </span>
                                    <h1 className="title">Place Bid</h1>
                                </div>
                                <div className="drawerBodyContainer">
                                    {/* <p className="paraText">
                                        Click Amount to enter a quick bid or enter your highest
                                        amount you’re willing to bid.
                                    </p> */}
                                    <div className="itemInfo">
                                        <ImageGallery
                                            items={selectedProductImage}
                                            thumbnailPosition="bottom"
                                            showThumbnails={false}
                                            showNav={true}
                                            showBullets={false}
                                            showFullscreenButton={false}
                                            showPlayButton={false}
                                            onErrorImageURL={`${global?.storeDetails?.logoValue}`}
                                            originalClass="slidImg img-fluid"
                                            renderItem={RenderImage}
                                            ref={sliderRef}
                                        />
                                        <div className="itemDetails">
                                            <h3
                                                className="title"
                                                dangerouslySetInnerHTML={{
                                                    __html: selectedProduct.title,
                                                }}
                                            />
                                            {/* <p className="ratailVal">
                                                <span>Retail Amount:</span>{' '}
                                                {currencyFormat(
                                                    parseFloat(selectedProduct.mprice).toFixed(2),
                                                )}
                                            </p> */}
                                            <div className="statusTag">
                                                <span
                                                    className={`status condition 
                                                    ${
                                                        selectedProduct.auctionnotes === 'New' ||
                                                        selectedProduct.auctionnotes === 'new'
                                                            ? 'condition_new'
                                                            : selectedProduct.auctionnotes ===
                                                              'Used'
                                                            ? 'condition_used'
                                                            : selectedProduct.auctionnotes ===
                                                              'Damaged'
                                                            ? 'condition_Damaged'
                                                            : selectedProduct.auctionnotes ===
                                                              'test'
                                                            ? 'condition_test'
                                                            : selectedProduct.auctionnotes ===
                                                              'Open Box'
                                                            ? 'condition_openbox'
                                                            : selectedProduct.auctionnotes ===
                                                              'Open-box'
                                                            ? 'condition_openbox'
                                                            : selectedProduct.auctionnotes ===
                                                              'Open-Box'
                                                            ? 'condition_openbox'
                                                            : selectedProduct.auctionnotes ===
                                                              'Test'
                                                            ? 'condition_test'
                                                            : selectedProduct.auctionnotes ===
                                                              'Like new'
                                                            ? 'condition_likenew'
                                                            : selectedProduct.auctionnotes ===
                                                              'Not Inspected'
                                                            ? 'condition_Damaged'
                                                            : selectedProduct.auctionnotes ===
                                                              'Uninspected'
                                                            ? 'condition_Damaged'
                                                            : selectedProduct.auctionnotes ===
                                                              'Untested'
                                                            ? 'condition_untested'
                                                            : 'condition_combain'
                                                    } mb-2
                                                `}
                                                >
                                                    {selectedProduct.auctionnotes}
                                                </span>
                                            </div>
                                            <p className="Pickuptxt" onClick={togglePopup}>
                                                Pickup Only{' '}
                                                <Tooltip
                                                    open={tipOpen}
                                                    onClose={handlehoverTioClose}
                                                    onOpen={handlehoverTioOpen}
                                                    placement="bottom-start"
                                                    title={
                                                        <Box sx={{ p: 1 }} className="tooltipBox">
                                                            {/* <h4 className="">Product Conditions</h4> */}
                                                            {!isVarifiedGfTheme ? (
                                                                <>
                                                                    {
                                                                        selectedProduct?.auction_address
                                                                    }
                                                                    ,{' '}
                                                                    {
                                                                        selectedProduct?.auctionlocation
                                                                    }
                                                                    ,{selectedProduct?.sell_zipcode}
                                                                </>
                                                            ) : isBargainsProject ? (
                                                                <>
                                                                    {' '}
                                                                    <p className="para d-flex align-items-center mb-0">
                                                                        <span className="material-icons-outlined">
                                                                            location_on
                                                                        </span>{' '}
                                                                        {selectedProduct?.auction_address
                                                                            ? `${selectedProduct?.auction_address} `
                                                                            : ''}
                                                                        {selectedProduct?.auction_city
                                                                            ? `${selectedProduct?.auction_city} `
                                                                            : ''}
                                                                        {selectedProduct?.auction_state
                                                                            ? `${selectedProduct?.auction_state} `
                                                                            : ''}
                                                                        {selectedProduct?.auction_zipcode
                                                                            ? selectedProduct?.auction_zipcode
                                                                            : ''}
                                                                    </p>
                                                                </>
                                                            ) : isBuyBestProject ? (
                                                                <>
                                                                    18 Blackjack Road, Suite 101,
                                                                    <br /> Fredericksburg, VA, 22405
                                                                </>
                                                            ) : (
                                                                <>
                                                                    4645 Morse Centre Rd.
                                                                    <br /> Columbus, OH 43229
                                                                </>
                                                            )}
                                                        </Box>
                                                    }
                                                >
                                                    <i className="material-icons-outlined ifo">
                                                        info
                                                    </i>
                                                </Tooltip>
                                            </p>
                                            <p className="bidTimer">
                                                <span className="bidCount">
                                                    {selectedProduct.bids} Bids{' '}
                                                </span>{' '}
                                                |{' '}
                                                <Timer
                                                    date_added={selectedProduct.date_added}
                                                    date_closed={
                                                        moment(
                                                            selectedProduct.date_closed,
                                                        ).isValid()
                                                            ? selectedProduct.date_closed
                                                            : oneYear
                                                    }
                                                    withText={1}
                                                    endText={' '}
                                                    startText={' '}
                                                    setUpcomming={setUpcomming}
                                                    audio={audio_loc}
                                                    viewPage={true}
                                                    theme="pvRRTheme"
                                                ></Timer>
                                            </p>
                                            {selectedProduct.auction == 1 ? (
                                                <p className="minBidCunt  mb-0">
                                                    <span className="mr-2">Minimum Bid</span>
                                                    {currencyFormat(
                                                        parseFloat(
                                                            selectedProduct.next_bid,
                                                        ).toFixed(2),
                                                    )}{' '}
                                                    {/* {selectedProduct.auction == 1 ? (
                                                        wdiscount > 0 ? (
                                                            <span className="ofF">
                                                                {wdiscount}% off
                                                            </span>
                                                        ) : (
                                                            ''
                                                        )
                                                    ) : discount > 0 &&
                                                      (selectedProduct?.bprice ||
                                                          !selectedProduct?.wprice) ? (
                                                        <span className="ofF">{discount}% off</span>
                                                    ) : (
                                                        ''
                                                    )} */}
                                                </p>
                                            ) : (
                                                ''
                                            )}
                                            {/* {isVarifiedGfTheme ? (
                                                <>
                                                    {isAuthenticated ? (
                                                        selectedProduct.buynow ? (
                                                            selectedProduct.wprice >=
                                                            selectedProduct.bprice ? null : (
                                                                <>
                                                                    {user?.id ==
                                                                    selectedProduct.user_id ? null : (
                                                                        <>
                                                                            {global
                                                                                .storeConfigration
                                                                                ?.buy_now_with_qty
                                                                                ?.value == 1 ? (
                                                                                <div>
                                                                                    <Qtyinput
                                                                                        type={
                                                                                            'slider'
                                                                                        }
                                                                                        total_qty={
                                                                                            selectedProduct.qty
                                                                                        }
                                                                                        qty={'1'}
                                                                                        product_id={
                                                                                            selectedProduct.id
                                                                                        }
                                                                                        selectedProduct={
                                                                                            selectedProduct
                                                                                        }
                                                                                        disabled={
                                                                                            disabled
                                                                                        }
                                                                                        history={
                                                                                            history
                                                                                        }
                                                                                        retail={1}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="">
                                                                                    <SecondaryButton
                                                                                        onClick={
                                                                                            handleClick
                                                                                        }
                                                                                        btnSize="pvBlogBtn"
                                                                                        disabled={
                                                                                            user?.status ==
                                                                                            'suspended'
                                                                                        }
                                                                                    >
                                                                                        {disabled
                                                                                            ? 'Remove from cart sssssssssss'
                                                                                            : `Buy now for ${currencyFormat(
                                                                                                  parseFloat(
                                                                                                      selectedProduct.bprice,
                                                                                                  ).toFixed(
                                                                                                      2,
                                                                                                  ),
                                                                                              )}`}
                                                                                    </SecondaryButton>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    <br />
                                                                </>
                                                            )
                                                        ) : null
                                                    ) : null}
                                                </>
                                            ) : null} */}
                                        </div>
                                    </div>
                                    <div className="biddingBoxBeat">
                                        {!isBargainsProject && (
                                            <>
                                                <div className="QuickUserBid">
                                                    <h2>Quick bid</h2>
                                                    <div className="quickBidContainer">
                                                        <Bidding
                                                            data={selectedProduct}
                                                            hard="1"
                                                            gfQuickBid={true}
                                                            audio={audio_loc}
                                                            gfThemeDrawer={true}
                                                            onClick={() => {
                                                                setTimeout(
                                                                    () => handleClose(),
                                                                    [2500],
                                                                )
                                                            }}
                                                            isBidLoading={isBidLoading}
                                                            setBidLoading={setBidLoading}
                                                        />
                                                    </div>
                                                </div>
                                                <span className="orDivider">OR</span>
                                            </>
                                        )}
                                        <div className="bidBtnContainer">
                                            <h4>
                                                Enter the highest amount you’re willing to bid.
                                                We’ll bid incrementally to keep you in the lead.
                                            </h4>
                                            <div className="bidingBoxWrapper">
                                                <Bidding
                                                    data={selectedProduct}
                                                    hard="0"
                                                    audio={audio_loc}
                                                    gfThemeDrawer={true}
                                                    drawerBidding={true}
                                                />
                                            </div>
                                            <Button
                                                className="CloseBtn"
                                                disableRipple
                                                onClick={() => {
                                                    handleClose()
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className={`prodInfoSlider`} style={{ paddingTop: '20px' }}>
                                <ImageGallery
                                    items={selectedProductImage}
                                    thumbnailPosition="right"
                                    showNav={true}
                                    showBullets={false}
                                    showFullscreenButton={false}
                                    showPlayButton={false}
                                    onErrorImageURL={`${global?.storeDetails?.logoValue}`}
                                    originalClass="slidImg img-fluid"
                                    renderItem={RenderImage}
                                    ref={sliderRef}
                                />
                                <div className="sliderBodyLink">
                                    <h3
                                        className="title"
                                        style={{ color: 'var(--primColor)' }}
                                        dangerouslySetInnerHTML={{
                                            __html: selectedProduct.title,
                                        }}
                                    />
                                    <h4 className="retailVal">
                                        Retail Value{' '}
                                        {currencyFormat(
                                            parseFloat(selectedProduct.mprice).toFixed(2),
                                        )}
                                    </h4>
                                    <div className="LotstatusBox">
                                        <span
                                            className={`status condition 
                                                    ${
                                                        selectedProduct.auctionnotes === 'New'
                                                            ? 'condition_new'
                                                            : selectedProduct.auctionnotes ===
                                                              'Used'
                                                            ? 'condition_used'
                                                            : selectedProduct.auctionnotes ===
                                                              'Damaged'
                                                            ? 'condition_Damaged'
                                                            : selectedProduct.auctionnotes ===
                                                              'test'
                                                            ? 'condition_test'
                                                            : selectedProduct.auctionnotes ===
                                                              'Open Box'
                                                            ? 'condition_openbox'
                                                            : selectedProduct.auctionnotes ===
                                                              'Open-box'
                                                            ? 'condition_openbox'
                                                            : selectedProduct.auctionnotes ===
                                                              'Open-Box'
                                                            ? 'condition_openbox'
                                                            : selectedProduct.auctionnotes ===
                                                              'Test'
                                                            ? 'condition_test'
                                                            : selectedProduct.auctionnotes ===
                                                              'Like new'
                                                            ? 'condition_likenew'
                                                            : selectedProduct.auctionnotes ===
                                                              'Not Inspected'
                                                            ? 'condition_Damaged'
                                                            : selectedProduct.auctionnotes ===
                                                              'Untested'
                                                            ? 'condition_untested'
                                                            : 'condition_combain'
                                                    } mb-2
                                                `}
                                        >
                                            {selectedProduct.auctionnotes}
                                        </span>
                                        <Tooltip
                                            open={tipOpen}
                                            onClose={handlehoverTioClose}
                                            onOpen={handlehoverTioOpen}
                                            placement="bottom-start"
                                            title={
                                                <Box sx={{ p: 1 }} className="tooltipBox">
                                                     <h4 className="">Product Conditions</h4>

                                                    {selectedProduct.auctionnotes === 'New' ? (
                                                        <p>
                                                            <strong>New</strong> — Brand new,
                                                            unopened, and unused in its original
                                                            packaging.
                                                        </p>
                                                    ) : selectedProduct.auctionnotes === 'Used' ? (
                                                        <p>
                                                            <strong>Used</strong> — Item has been
                                                            previously used and may show signs of
                                                            wear. Fully functional unless stated
                                                            otherwise.
                                                        </p>
                                                    ) : selectedProduct.auctionnotes ===
                                                      'Damaged' ? (
                                                        <p>
                                                            <strong>Damaged</strong> — Item has
                                                            visible damage and may be
                                                            non-functional. Sold AS-IS with no
                                                            guarantees.
                                                        </p>
                                                    ) : selectedProduct.auctionnotes?.toLowerCase() ===
                                                      'test' ? (
                                                        <p>
                                                            <strong>Test</strong> — Item was tested
                                                            and its functionality is partially or
                                                            fully confirmed.
                                                        </p>
                                                    ) : selectedProduct.auctionnotes?.toLowerCase() ===
                                                      'open-box' ? (
                                                        <p>
                                                            <strong>Open Box</strong> — Items were
                                                            sold by a retailer and possibly used
                                                            before being returned. May have cosmetic
                                                            wear or missing accessories. All Open
                                                            Box items are sold AS-IS unless
                                                            otherwise stated.
                                                        </p>
                                                    ) : selectedProduct.auctionnotes ===
                                                      'Like new' ? (
                                                        <p>
                                                            <strong>Like New</strong> — Item appears
                                                            and functions like new, with little to
                                                            no signs of use. Often includes original
                                                            packaging.
                                                        </p>
                                                    ) : selectedProduct.auctionnotes ===
                                                      'Not Inspected' ? (
                                                        <p>
                                                            <strong>Not Inspected</strong> — Item
                                                            has not been tested or reviewed for
                                                            condition. Sold AS-IS.
                                                        </p>
                                                    ) : selectedProduct.auctionnotes ===
                                                      'Untested' ? (
                                                        <p>
                                                            <strong>Untested</strong> — The item
                                                            functionality has not been verified.
                                                            Condition unknown and sold AS-IS.
                                                        </p>
                                                    ) : (
                                                        <p>{selectedProduct.auctionnotes}</p>
                                                    )}
                                                </Box>
                                            }
                                        >
                                            <i className="material-icons-outlined ifo">info</i>
                                        </Tooltip>
                                    </div>
                                    <p className="Pickuptxt" onClick={togglePopup}>
                                        Pick Up Only - click to see details{' '}
                                    </p>
                                    <div className="boxBidContr">
                                        <p className="bidCountBox mb-0">
                                            <span>
                                                <Timer
                                                    date_added={selectedProduct.date_added}
                                                    date_closed={
                                                        moment(
                                                            selectedProduct.date_closed,
                                                        ).isValid()
                                                            ? selectedProduct.date_closed
                                                            : oneYear
                                                    }
                                                    withText={1}
                                                    endText={' '}
                                                    startText={' '}
                                                    setUpcomming={setUpcomming}
                                                    audio={audio_loc}
                                                    viewPage={true}
                                                    theme="pvRRTheme"
                                                ></Timer>
                                            </span>
                                        </p>

                                        {selectedProduct.auction == 1 ? (
                                            <p className="minBidCunt  mb-0">
                                                Minimum Bid{' '}
                                                {currencyFormat(
                                                    parseFloat(selectedProduct.next_bid).toFixed(2),
                                                )}{' '}
                                                {selectedProduct.auction == 1 ? (
                                                    wdiscount > 0 ? (
                                                        <span>{wdiscount}% off</span>
                                                    ) : (
                                                        ''
                                                    )
                                                ) : discount > 0 &&
                                                  (selectedProduct?.bprice ||
                                                      !selectedProduct?.wprice) ? (
                                                    <span>{discount}% off</span>
                                                ) : (
                                                    ''
                                                )}
                                            </p>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                    <h4 className="OffVal">
                                        {selectedProduct.bids ? 'Current Price :' : 'Start Price :'}
                                        {currencyFormat(
                                            parseFloat(selectedProduct.wprice).toFixed(2),
                                        )}
                                    </h4>
                                    {selectedProduct?.bundle_id ? (
                                        <div className="mssBidInfo">
                                            <PrimaryButton
                                                label={'Download Manifest'}
                                                btnSize="small"
                                                // disabled={calc_loading}
                                                onClick={() => {
                                                    DownloadManifest(selectedProduct?.bundle_id)
                                                }}
                                            />
                                        </div>
                                    ) : null}
                                    <p className="PremiunVal">
                                        Buyers Premium {selectedProduct.buyerpremium_percentage}%{' '}
                                        <Tooltip
                                            open={prmtipOpen}
                                            onClose={handlehoverPrmTioClose}
                                            onOpen={handlehoverPrmTioOpen}
                                            placement="bottom-start"
                                            title={
                                                <Box sx={{ p: 1 }} className="tooltipBox">
                                                    <p>
                                                        This is a{' '}
                                                        {selectedProduct.buyerpremium_percentage}%
                                                        fee added to the final bid amount. Its paid
                                                        by the buyer and goes to the auction house.
                                                    </p>
                                                </Box>
                                            }
                                        >
                                            <i className="material-icons-outlined ifo">info</i>
                                        </Tooltip>
                                    </p>

                                    <div className="bidBtnContainer">
                                        <div className="bidingBOxWrapper">
                                            <Bidding
                                                data={selectedProduct}
                                                hard="0"
                                                audio={audio_loc}
                                                gfThemeBidSlider={true}
                                            />
                                        </div>
                                        <button
                                            className="CloseBtn"
                                            onClick={() => {
                                                handleClose()
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    ) : (
                        <div className="container pt-5">
                            <NoRecordsFound />
                        </div>
                    )}
                    <Popup open={pickUpPopup} handleClose={togglePopup}>
                        {' '}
                        <div className="bids-row">
                            <div className="media pl-media">
                                <div className="media-left">
                                    <img src="/lots-images/pickup.svg" alt="" />
                                </div>
                                <div className="media-body">
                                    <h5>Pickup Location:</h5>
                                    {!isVarifiedGfTheme ? (
                                        <>
                                            {!isRRThemeSlidePanel ? (
                                                <address>
                                                    {selectedProduct?.auctionlocation}
                                                </address>
                                            ) : (
                                                <address>
                                                    {`${selectedProduct?.auction_address},
                                            ${selectedProduct?.auctionlocation},
                                            ${selectedProduct?.sell_zipcode}`}
                                                </address>
                                            )}
                                        </>
                                    ) : isBargainsProject ? (
                                        <>
                                            <p className="para d-flex align-items-center mb-0">
                                                <span className="material-icons-outlined">
                                                    location_on
                                                </span>{' '}
                                                {selectedProduct?.auction_address
                                                    ? `${selectedProduct?.auction_address} `
                                                    : ''}
                                                {selectedProduct?.auction_city
                                                    ? `${selectedProduct?.auction_city} `
                                                    : ''}
                                                {selectedProduct?.auction_state
                                                    ? `${selectedProduct?.auction_state} `
                                                    : ''}
                                                {selectedProduct?.auction_zipcode
                                                    ? selectedProduct?.auction_zipcode
                                                    : ''}
                                            </p>
                                        </>
                                    ) : (
                                        <address>
                                            {isBuyBestProject ? (
                                                <>
                                                    18 Blackjack Road, Suite 101,
                                                    <br /> Fredericksburg, VA, 22405
                                                </>
                                            ) : (
                                                <>
                                                    {' '}
                                                    4645 Morse Centre Rd.
                                                    <br />
                                                    Columbus, OH 43229
                                                </>
                                            )}
                                        </address>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Popup>
                </>
            )}
        </>
    )
    const render = (
        <>
            {loading ? (
                <div className="sliderLoader">
                    <Loaders name="product_view" isLoading={loading} loop={1} />
                </div>
            ) : (
                <>
                    {selectedProduct?.id ? (
                        <div
                            style={{
                                background: '#fff',
                                minHeight: '100vh',
                                // overflowY: 'auto',
                                padding: '25px',
                            }}
                        >
                            {global?.pluginConfiguration?.advertisement?.enable == 1 ? (
                                <div className="siteAds adsProd">
                                    {isMobile
                                        ? prodAds?.mobProdTop[activeProdAdsIndex?.mobProdTop]
                                        : prodAds?.deskProdTop[activeProdAdsIndex?.deskProdTop]}
                                </div>
                            ) : null}
                            <Button
                                onClick={() => {
                                    history.goBack()
                                    window.scrollTo(0, 0)
                                }}
                                className="moveBack"
                            >
                                <span className="material-icons mr-3">arrow_back</span>
                                {'back'}
                            </Button>
                            <div className="media-body position-relative">
                                {!viewPage && (
                                    <img
                                        src="/image/close.png"
                                        onClick={() => {
                                            handleClose()
                                        }}
                                        className="close-img"
                                        height="35"
                                        width="35"
                                    />
                                )}
                                <div
                                    className={`prodInfoSlider pb-4`}
                                    style={{ paddingTop: '20px' }}
                                >
                                    {isAuthenticated &&
                                    global?.storeConfigration?.bid_box_bidding_message?.value !=
                                        1 ? (
                                        selectedProduct.auction ? (
                                            type === 'buynow' ? null : (
                                                <BidStatus
                                                    bidTopStatus={selectedProduct.bidtopstatus}
                                                />
                                            )
                                        ) : null
                                    ) : null}

                                    {global?.storeConfigration?.magnify_image_gallery?.value ==
                                    1 ? (
                                        <MagnifyImageGallery images={selectedProductImage} />
                                    ) : (
                                        <ImageGallery
                                            items={selectedProductImage}
                                            thumbnailPosition="bottom"
                                            showNav={true}
                                            showBullets={false}
                                            showFullscreenButton={true}
                                            showPlayButton={false}
                                            onErrorImageURL={`${global?.storeDetails?.logoValue}`}
                                            originalClass="slidImg img-fluid"
                                            // renderCustomControls={RenderImageZoom}
                                            renderItem={RenderImage}
                                            ref={sliderRef}
                                        />
                                    )}
                                    <div className="d-flex justify-content-between align-items-center pvTitleContainer flex-wrap">
                                        <div>
                                            {/* {homeDepot.price && homeDepot.product_url ? (
                                                <h5 className="lotNo">
                                                    <a
                                                        href={homeDepot.product_url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {selectedProduct.retailer_name} Retail Price
                                                        -{' '}
                                                        {currencyFormat(
                                                            parseFloat(homeDepot.price).toFixed(2),
                                                        )}{' '}
                                                        {/* - {homeDepot.date} 
                                                    </a>
                                                </h5>
                                            ) : null} */}
                                            {/* {ASIN.price && ASIN.product_url ? (
                                                <h5 className="lotNo">
                                                    <a
                                                        href={ASIN.product_url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {selectedProduct.retailer_name} Retail Price
                                                        -{' '}
                                                        {currencyFormat(
                                                            parseFloat(ASIN.price).toFixed(2),
                                                        )}{' '}
                                                    </a>
                                                </h5>
                                            ) : null} */}

                                            {retailerInfo.price &&
                                            retailerInfo.product_url &&
                                            retailerInfo.retailer_name ? (
                                                <h5 className="lotNo">
                                                    <a
                                                        href={retailerInfo.product_url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {retailerInfo.retailer_name ||
                                                            selectedProduct.retailer_name}{' '}
                                                        Retail Price -{' '}
                                                        {currencyFormat(
                                                            parseFloat(retailerInfo.price).toFixed(
                                                                2,
                                                            ),
                                                        )}{' '}
                                                    </a>
                                                </h5>
                                            ) : null}
                                            {global?.storeConfigration?.hide_lot_id?.value ==
                                            1 ? null : (
                                                <h5 className="lotNo">
                                                    Lot#{' '}
                                                    {selectedProduct.sku && selectedProduct.sku != 0
                                                        ? selectedProduct.sku
                                                        : selectedProduct.lot_number
                                                        ? selectedProduct.lot_number
                                                        : selectedProduct.deed_document
                                                        ? selectedProduct.deed_document
                                                        : selectedProduct.id}
                                                </h5>
                                            )}
                                            {global?.storeConfigration?.lot_sequence_order?.value ==
                                            1 ? (
                                                <h5 className="lotNo">
                                                    Lot #:{' '}
                                                    {selectedProduct.deed_document
                                                        ? selectedProduct.deed_document
                                                        : '-'}
                                                </h5>
                                            ) : (
                                                <h5 className="lotNo">
                                                    Lot Number:{' '}
                                                    <span>
                                                        {selectedProduct?.lot_number !== ''
                                                            ? selectedProduct?.lot_number
                                                            : '-'}
                                                    </span>
                                                </h5>
                                            )}
                                            {global?.storeConfigration?.hide_product_id_all
                                                ?.value == 1 ? null : (
                                                <h5 className="lotNo">
                                                    Product ID:{' '}
                                                    {selectedProduct.store_product_id
                                                        ? selectedProduct.store_product_id
                                                        : selectedProduct.id}
                                                </h5>
                                            )}
                                            {global.pluginConfiguration?.remote_seller?.enable ? (
                                                <div className="pv-con">
                                                    <span>Posted By:</span>
                                                    {selectedProduct.username}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                            {global?.storeConfigration?.show_bin_location?.value ==
                                            2 ? (
                                                <h5 className="lotNo">
                                                    Bin Location:{' '}
                                                    {selectedProduct.budget_type
                                                        ? selectedProduct.budget_type
                                                        : '-'}
                                                </h5>
                                            ) : null}
                                            {parseInt(selectedProduct.buynow) == 0 &&
                                            (parseInt(selectedProduct.lowest) ||
                                                parseInt(selectedProduct.highest)) ? (
                                                <p>
                                                    <span>Est:</span>
                                                    {`${
                                                        ' ' +
                                                        currencyFormat(selectedProduct.lowest) +
                                                        ' - ' +
                                                        currencyFormat(selectedProduct.highest)
                                                    }`}
                                                </p>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                        {global?.storeConfigration?.unique_slot4?.value != 1 ? (
                                            <div className="pvMiscActions">
                                                <a
                                                    target="_blank"
                                                    className="searchExt"
                                                    rel="noreferrer"
                                                    href={`https://www.google.com/search?q=${selectedProduct.title}`}
                                                >
                                                    <span className="material-icons">search</span>
                                                </a>
                                                <FavouriteCheckbox
                                                    watchlisted={selectedProduct.wlistpop}
                                                    data={selectedProduct}
                                                    project_id={selectedProduct.id}
                                                    getAllProducts={getAllProducts}
                                                    setSelectedProduct={setSelectedProduct}
                                                    from={from}
                                                />
                                                <div
                                                    className="cpyToClipDiv"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Copy
                                                        text={`${
                                                            global.storeDetails?.theme == 2
                                                                ? `/search?product=${selectedProduct.id}`
                                                                : `/product?id=${selectedProduct.id}`
                                                        }`}
                                                    />
                                                </div>
                                                <Email
                                                    path={`/product/${selectedProduct.id}`}
                                                    subject={selectedProduct.title}
                                                    body={removeHTMLTags(
                                                        selectedProduct.description,
                                                    )}
                                                />
                                                <Facebook
                                                    path={`/product/${selectedProduct.id}`}
                                                    title={selectedProduct.title}
                                                />
                                                {global?.storeConfigration?.disable_whatsapp_sharing
                                                    ?.value == 1 ? null : (
                                                    <Whatsapp
                                                        path={`/product/${selectedProduct.id}`}
                                                        title={selectedProduct.title}
                                                    />
                                                )}
                                                {global?.storeConfigration?.disable_twitter_sharing
                                                    ?.value == 1 ? null : (
                                                    <Twitter
                                                        path={`/product/${selectedProduct.id}`}
                                                        title={selectedProduct.title}
                                                    />
                                                )}
                                                {global?.storeConfigration
                                                    ?.disable_pinterest_sharing?.value ==
                                                1 ? null : (
                                                    <Pinterest
                                                        path={`/product/${selectedProduct.id}`}
                                                        title={selectedProduct.title}
                                                        media={
                                                            `${
                                                                selectedProduct.content_head1 ===
                                                                '0'
                                                                    ? process.env
                                                                          .REACT_APP_BASE_URL +
                                                                      'uploads/product/'
                                                                    : process.env
                                                                          .REACT_APP_PRODUCT_IMAGE_URL
                                                            }` + selectedProduct.avatar
                                                        }
                                                    />
                                                )}
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                    <h3
                                        className="plTitle"
                                        style={{ color: 'var(--primColor)' }}
                                        dangerouslySetInnerHTML={{
                                            __html: selectedProduct.title,
                                        }}
                                    />
                                    {hawaiiBodyClass ? (
                                        <div className="widthByHawaiiTheme">
                                            <div className="pv-con">
                                                <span>Description:</span>
                                            </div>
                                            <p
                                                key={selectedProduct.id}
                                                dangerouslySetInnerHTML={{
                                                    __html: selectedProduct.description,
                                                }}
                                            ></p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="pv-con">
                                                <span>Description:</span>
                                            </div>
                                            <p
                                                key={selectedProduct.id}
                                                dangerouslySetInnerHTML={{
                                                    __html: selectedProduct.description,
                                                }}
                                            ></p>
                                        </>
                                    )}
                                    {selectedProduct.location &&
                                    !selectedProduct?.location?.includes('[') ? (
                                        <div
                                            className={
                                                hawaiiBodyClass
                                                    ? 'd-flex align-items-baseline widthByHawaiiTheme justify-content-start'
                                                    : 'd-flex align-items-baseline justify-content-start'
                                            }
                                        >
                                            <div className="pv-con">
                                                <span>Warehouse Location:</span>
                                            </div>
                                            <p className="">{selectedProduct.location}</p>
                                        </div>
                                    ) : null}
                                    <div
                                        className={
                                            hawaiiBodyClass
                                                ? 'd-flex align-items-baseline widthByHawaiiTheme justify-content-start'
                                                : 'd-flex align-items-baseline justify-content-start'
                                        }
                                    >
                                        <div className="pv-con">
                                            <span>Condition:</span>
                                        </div>
                                        {global?.storeConfigration?.condition_field?.value == 1 ? (
                                            <p>
                                                {selectedProduct.extra_fields
                                                    ? JSON.parse(selectedProduct.extra_fields)
                                                          .condition_field
                                                    : '-'}
                                            </p>
                                        ) : global?.condition_data?.find(
                                              (val) =>
                                                  val.condition == selectedProduct.auctionnotes,
                                          )?.content ? (
                                            <>
                                                <Tooltip
                                                    title={
                                                        global?.condition_data?.find(
                                                            (val) =>
                                                                val.condition ==
                                                                selectedProduct.auctionnotes,
                                                        )?.content
                                                    }
                                                    arrow
                                                    placement="top-start"
                                                    opensOn="Hover"
                                                    open={showToolTipCondition}
                                                    onOpen={() => setShowToolTipCondition(true)}
                                                    onClose={() => setShowToolTipCondition(false)}
                                                >
                                                    <Button
                                                        onClick={() =>
                                                            setShowToolTipCondition(
                                                                !showToolTipCondition,
                                                            )
                                                        }
                                                        className="tooling"
                                                    >
                                                        <span>i</span>
                                                    </Button>
                                                </Tooltip>
                                                <p
                                                    // className="ml-4"
                                                    dangerouslySetInnerHTML={{
                                                        __html: selectedProduct.auctionnotes,
                                                    }}
                                                ></p>
                                            </>
                                        ) : (
                                            <p>
                                                {selectedProduct.auctionnotes
                                                    ? selectedProduct.auctionnotes
                                                    : selectedProduct.conditionunique
                                                    ? selectedProduct.conditionunique
                                                    : null}
                                            </p>
                                        )}
                                    </div>
                                    {global?.storeConfigration?.need_transferable?.value == 1 ? (
                                        <div
                                            className={
                                                hawaiiBodyClass
                                                    ? 'd-flex align-items-baseline widthByHawaiiTheme justify-content-start'
                                                    : 'd-flex align-items-baseline justify-content-start'
                                            }
                                        >
                                            <div className="pv-con">
                                                <span>Transferable:</span>
                                            </div>
                                            {selectedProduct.transferable ? (
                                                <Tooltip
                                                    title={
                                                        selectedProduct.transferable == 'Yes'
                                                            ? 'This item can be transfered to a different warehouse location for pickup.'
                                                            : selectedProduct.transferable == 'No'
                                                            ? 'This item must be picked up from its original location.'
                                                            : ''
                                                    }
                                                    arrow
                                                    placement="top-start"
                                                    open={showTooltip}
                                                    onOpen={() => setShowTooltip(true)}
                                                    onClose={() => setShowTooltip(false)}
                                                    opensOn="Click"
                                                    className="tooling"
                                                >
                                                    <span
                                                        onClick={() => setShowTooltip(!showTooltip)}
                                                    >
                                                        i
                                                    </span>
                                                </Tooltip>
                                            ) : (
                                                ''
                                            )}
                                            <p>
                                                {selectedProduct.transferable
                                                    ? selectedProduct.transferable
                                                    : ' - '}
                                            </p>
                                        </div>
                                    ) : null}

                                    {global.pluginConfiguration?.most_viewed?.enable == 1 &&
                                    selectedProduct.viwers ? (
                                        <>
                                            {hawaiiBodyClass ? (
                                                <div className="widthByHawaiiTheme">
                                                    <div className="pv-con">
                                                        <span>Viewers:</span>
                                                    </div>
                                                    <p>{selectedProduct.viwers}</p>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="pv-con">
                                                        <span>Viewers:</span>
                                                    </div>
                                                    <p>{selectedProduct.viwers}</p>
                                                </>
                                            )}
                                        </>
                                    ) : null}
                                    {selectedProduct.mprice ? (
                                        <>
                                            {hawaiiBodyClass ? (
                                                <div className="widthByHawaiiTheme">
                                                    {' '}
                                                    <div className="pv-con">
                                                        <span>Retail Price</span>
                                                    </div>
                                                    <p>
                                                        {currencyFormat(
                                                            parseFloat(
                                                                selectedProduct.mprice,
                                                            ).toFixed(2),
                                                        )}
                                                    </p>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="pv-con">
                                                        <span>Retail Price:</span>
                                                    </div>
                                                    <p>
                                                        {currencyFormat(
                                                            parseFloat(
                                                                selectedProduct.mprice,
                                                            ).toFixed(2),
                                                        )}
                                                    </p>
                                                </>
                                            )}
                                        </>
                                    ) : null}
                                    <div
                                        className={
                                            hawaiiBodyClass ? 'row widthByHawaiiThemes' : 'row'
                                        }
                                    >
                                        <div className="col-md-8">
                                            {selectedProduct.auction == 1 ? (
                                                <div className="pv-con">
                                                    <span>
                                                        {selectedProduct.bids
                                                            ? 'Current '
                                                            : 'Start '}
                                                        Price:
                                                    </span>
                                                    <p
                                                        className={`${
                                                            selectedProduct.bidtopstatus.includes(
                                                                'bought',
                                                            ) ||
                                                            selectedProduct.bidtopstatus.includes(
                                                                'won',
                                                            )
                                                                ? 'won'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'lost',
                                                                  )
                                                                ? 'lost'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'losing',
                                                                  )
                                                                ? 'losing'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'outbid',
                                                                  )
                                                                ? 'outbid'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'reserve',
                                                                  )
                                                                ? 'reserve'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'winning',
                                                                  )
                                                                ? 'winning'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'proxy',
                                                                  )
                                                                ? 'proxy'
                                                                : ''
                                                        }`}
                                                    >
                                                        {currencyFormat(
                                                            parseFloat(
                                                                selectedProduct.wprice,
                                                            ).toFixed(2),
                                                        )}
                                                    </p>
                                                    {selectedProduct.bidtopstatus ? (
                                                        <span
                                                            className={`p4 ${
                                                                selectedProduct.bidtopstatus.includes(
                                                                    'bought',
                                                                ) ||
                                                                selectedProduct.bidtopstatus.includes(
                                                                    'won',
                                                                )
                                                                    ? 'won'
                                                                    : selectedProduct.bidtopstatus.includes(
                                                                          'lost',
                                                                      )
                                                                    ? 'lost'
                                                                    : selectedProduct.bidtopstatus.includes(
                                                                          'losing',
                                                                      )
                                                                    ? 'losing'
                                                                    : selectedProduct.bidtopstatus.includes(
                                                                          'outbid',
                                                                      )
                                                                    ? 'outbid'
                                                                    : selectedProduct.bidtopstatus.includes(
                                                                          'reserve',
                                                                      )
                                                                    ? 'reserve'
                                                                    : selectedProduct.bidtopstatus.includes(
                                                                          'winning',
                                                                      )
                                                                    ? 'winning'
                                                                    : selectedProduct.bidtopstatus.includes(
                                                                          'proxy',
                                                                      )
                                                                    ? 'proxy'
                                                                    : ''
                                                            }`}
                                                        >
                                                            {selectedProduct.bidtopstatus.includes(
                                                                'bought',
                                                            ) ||
                                                            selectedProduct.bidtopstatus.includes(
                                                                'won',
                                                            )
                                                                ? 'won'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'lost',
                                                                  )
                                                                ? 'lost'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'losing',
                                                                  )
                                                                ? 'losing'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'outbid',
                                                                  )
                                                                ? 'outbid'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'reserve',
                                                                  )
                                                                ? 'reserve'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'winning',
                                                                  )
                                                                ? 'winning'
                                                                : selectedProduct.bidtopstatus.includes(
                                                                      'proxy',
                                                                  )
                                                                ? 'proxy'
                                                                : ''}
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}
                                                    {selectedProduct.bids &&
                                                    selectedProduct.rprice &&
                                                    parseFloat(selectedProduct.rprice) > 0 ? (
                                                        parseFloat(selectedProduct?.wprice) >=
                                                        parseFloat(selectedProduct?.rprice) ? (
                                                            <span style={{ color: '#838383' }}>
                                                                (Reserve has been met)
                                                            </span>
                                                        ) : (
                                                            <span style={{ color: '#8B0000' }}>
                                                                (Reserve has not been met yet)
                                                            </span>
                                                        )
                                                    ) : null}
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="pv-con">
                                                        <span>Buy now Price:</span>
                                                        {currencyFormat(
                                                            parseFloat(
                                                                selectedProduct.bprice,
                                                            ).toFixed(2),
                                                        )}
                                                    </div>
                                                    {global?.storeConfigration?.buy_now_with_qty
                                                        ?.value == 1 &&
                                                    global?.storeConfigration?.unique_slot4
                                                        ?.value != 1 ? (
                                                        <div className="pv-con">
                                                            <span>Available Qty:</span>
                                                            {selectedProduct.qty}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}

                                                    {global?.storeConfigration?.qty_input_slider
                                                        ?.value == 1 ? (
                                                        <div>
                                                            <Qtyinput
                                                                type={'slider'}
                                                                total_qty={selectedProduct.qty}
                                                                qty={'1'}
                                                                product_id={selectedProduct.id}
                                                                disabled={disabled}
                                                                history={history}
                                                            />
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}

                                                    {global?.storeConfigration?.unique_slot4
                                                        ?.value == 1 ? (
                                                        <>
                                                            <div className="pv-con">
                                                                <span>Total Qty:</span>
                                                                {selectedProduct.qty +
                                                                    selectedProduct.sold}
                                                            </div>
                                                            <div className="pv-con">
                                                                <span>Available Qty:</span>
                                                                {selectedProduct.qty}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        ''
                                                    )}
                                                </>
                                            )}
                                            <div className="pv-con">
                                                {type !== 'buynow' && selectedProduct.auction ? (
                                                    <>
                                                        <span>Total Bids: </span>
                                                        <a
                                                            className="tb-link"
                                                            onClick={() =>
                                                                selectedProduct.bids &&
                                                                selectedProduct.bids !== 0 &&
                                                                !selectedProduct.is_past &&
                                                                setHistoryData({
                                                                    product_id: selectedProduct.id,
                                                                    end: moment(
                                                                        selectedProduct.date_closed,
                                                                    ).isValid()
                                                                        ? selectedProduct.date_closed
                                                                        : oneYear,
                                                                })
                                                            }
                                                        >
                                                            {selectedProduct.bids
                                                                ? selectedProduct.bids
                                                                : 0}
                                                        </a>
                                                    </>
                                                ) : (
                                                    ''
                                                )}

                                                {parseInt(selectedProduct.buynow) == 0 ? (
                                                    <div className="pv-con1 svInfo">
                                                        <span>{`Closing Date: `}</span>
                                                        {moment(
                                                            moment(
                                                                selectedProduct.date_closed,
                                                            ).isValid()
                                                                ? selectedProduct.date_closed
                                                                : oneYear,
                                                        ).format('MMM Do YYYY, h:mm:ss a')}{' '}
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                                {global.storeConfigration?.show_buyer_premium
                                                    ?.value == 1 ? (
                                                    <div className="pv-con1 svInfo">
                                                        <span>{"Buyer's Premium:"}</span>
                                                        {selectedProduct.buyerpremium_percentage +
                                                            ' %'}
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                            {/*Shipping Plugin Added Flow Start*/}
                                            {parseInt(selectedProduct.hasshipping) &&
                                            global.pluginConfiguration?.shipping?.enable &&
                                            isAuthenticated ? (
                                                <div className="pv-con">
                                                    <p>
                                                        Rates based on Shipping Address on profile.{' '}
                                                        Update
                                                        <Link to="/dashboard/profile">here</Link>
                                                    </p>
                                                    {shipping_amount ? (
                                                        <>
                                                            {/* <div className="pv-con"> */}
                                                            <span>Shipping Amount</span>

                                                            {currencyFormat(
                                                                parseFloat(shipping_amount).toFixed(
                                                                    2,
                                                                ),
                                                            )}
                                                            {/* </div> */}
                                                        </>
                                                    ) : (
                                                        <PrimaryButton
                                                            label="Calculate Shipping"
                                                            btnSize="small"
                                                            onClick={() =>
                                                                calculate_shipstation_amount()
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}

                                            {/*Shipping Plugin Added Flow End*/}
                                        </div>
                                        {selectedProduct.auction == 1 ? (
                                            <div className="col-md-4 text-center-md mt-90 hide-timmer-sunrise">
                                                <div className="timer-wrapper">
                                                    <div>
                                                        <img
                                                            src="/image/timer.svg"
                                                            alt=""
                                                            className="lv-timer"
                                                        />
                                                    </div>
                                                    {selectedProduct.market_status != 'open' ||
                                                    selectedProduct.productClosed ? (
                                                        'Closed'
                                                    ) : selectedProduct.extend ||
                                                      selectedProduct.agent_id ? (
                                                        <span className="tmm">
                                                            <Timer
                                                                date_added={
                                                                    selectedProduct.date_added
                                                                }
                                                                date_closed={
                                                                    moment(
                                                                        selectedProduct.date_closed,
                                                                    ).isValid()
                                                                        ? selectedProduct.date_closed
                                                                        : oneYear
                                                                }
                                                                withText={1}
                                                                endText={'Ends in' + ':'}
                                                                startText={'Starts in' + ':'}
                                                                setUpcomming={setUpcomming}
                                                                audio={audio_loc}
                                                            ></Timer>
                                                        </span>
                                                    ) : (
                                                        <span>
                                                            <Timer
                                                                date_added={
                                                                    selectedProduct.date_added
                                                                }
                                                                date_closed={
                                                                    moment(
                                                                        selectedProduct.date_closed,
                                                                    ).isValid()
                                                                        ? selectedProduct.date_closed
                                                                        : oneYear
                                                                }
                                                                withText={1}
                                                                endText={'Ends in' + ':'}
                                                                startText={'Starts in' + ':'}
                                                                setUpcomming={setUpcomming}
                                                                audio={audio_loc}
                                                            ></Timer>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                    {global?.pluginConfiguration?.advertisement?.enable == 1 ? (
                                        <div className="siteAds adsProd">
                                            {isMobile
                                                ? prodAds?.mobProdMid[
                                                      activeProdAdsIndex?.mobProdMid
                                                  ]
                                                : prodAds?.deskProdMid[
                                                      activeProdAdsIndex?.deskProdMid
                                                  ]}
                                        </div>
                                    ) : null}
                                    {selectedProduct.market_status != 'open' ||
                                    selectedProduct.productClosed ? (
                                        <b>Lot Closed</b>
                                    ) : (
                                        <div
                                            className={`sl-pbids slidView ${
                                                !isAuthenticated && 'notLogged'
                                            }`}
                                        >
                                            {isAuthenticated &&
                                            global?.storeConfigration?.bid_box_bidding_message
                                                ?.value == 1 ? (
                                                selectedProduct.auction ? (
                                                    type === 'buynow' ? null : (
                                                        <BidStatus
                                                            bidTopStatus={
                                                                selectedProduct.bidtopstatus
                                                            }
                                                        />
                                                    )
                                                ) : null
                                            ) : null}
                                            {isAuthenticated ||
                                            global?.storeConfigration?.guest_user_login?.value ? (
                                                <>
                                                    {selectedProduct.auction &&
                                                    selectedProduct?.user_id == user?.id ? (
                                                        <p>You cannot bid your own product!</p>
                                                    ) : global.pluginConfiguration?.reverse_auction
                                                          ?.enable &&
                                                      selectedProduct.content_head5 == 1 ? (
                                                        <Biddingforwardandreverse
                                                            theme="multiseller"
                                                            data={selectedProduct}
                                                            hard="1"
                                                            is_registered={is_registered}
                                                            private_auction={private_auction}
                                                        />
                                                    ) : global.pluginConfiguration?.make_an_offer
                                                          ?.enable ? (
                                                        <>
                                                            {selectedProduct?.make_an_offer_io &&
                                                            upcomming ? (
                                                                ''
                                                            ) : (
                                                                <>
                                                                    {' '}
                                                                    {selectedProduct.auction ? (
                                                                        type === 'buynow' &&
                                                                        !selectedProduct.auction ? null : (
                                                                            <>
                                                                                {global
                                                                                    .storeConfigration
                                                                                    ?.hard_bid
                                                                                    ?.value ==
                                                                                    '1' && (
                                                                                    <>
                                                                                        <p className="slidViewBtnLabel">
                                                                                            <span className="material-icons">
                                                                                                info
                                                                                            </span>
                                                                                            Hard Bid
                                                                                            - Bid on
                                                                                            the
                                                                                            current
                                                                                            price
                                                                                        </p>
                                                                                        <Bidding
                                                                                            data={
                                                                                                selectedProduct
                                                                                            }
                                                                                            hard="1"
                                                                                            audio={
                                                                                                audio_loc
                                                                                            }
                                                                                        />
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )
                                                                    ) : null}
                                                                    {selectedProduct.auction ? (
                                                                        type === 'buynow' &&
                                                                        !selectedProduct.auction ? null : (
                                                                            <>
                                                                                {global
                                                                                    .storeConfigration
                                                                                    ?.proxy_bid
                                                                                    ?.value ==
                                                                                    '1' && (
                                                                                    <>
                                                                                        <p className="slidViewBtnLabel">
                                                                                            <span className="material-icons">
                                                                                                info
                                                                                            </span>
                                                                                            Proxy
                                                                                            Bid -
                                                                                            System
                                                                                            will
                                                                                            auto bid
                                                                                            upto the
                                                                                            amount
                                                                                            entered
                                                                                        </p>
                                                                                        <Bidding
                                                                                            data={
                                                                                                selectedProduct
                                                                                            }
                                                                                            hard="0"
                                                                                            audio={
                                                                                                audio_loc
                                                                                            }
                                                                                        />
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {' '}
                                                            {selectedProduct.auction ? (
                                                                type === 'buynow' &&
                                                                !selectedProduct.auction ? null : (
                                                                    <>
                                                                        {global.storeConfigration
                                                                            ?.hard_bid?.value ==
                                                                            '1' && (
                                                                            <>
                                                                                <p className="slidViewBtnLabel">
                                                                                    <span className="material-icons">
                                                                                        info
                                                                                    </span>
                                                                                    Hard Bid - Bid
                                                                                    on the current
                                                                                    price
                                                                                </p>
                                                                                <Bidding
                                                                                    data={
                                                                                        selectedProduct
                                                                                    }
                                                                                    hard="1"
                                                                                    audio={
                                                                                        audio_loc
                                                                                    }
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </>
                                                                )
                                                            ) : null}
                                                            {selectedProduct.auction ? (
                                                                type === 'buynow' &&
                                                                !selectedProduct.auction ? null : (
                                                                    <>
                                                                        {global.storeConfigration
                                                                            ?.proxy_bid?.value ==
                                                                            '1' && (
                                                                            <>
                                                                                <p className="slidViewBtnLabel">
                                                                                    <span className="material-icons">
                                                                                        info
                                                                                    </span>
                                                                                    Proxy Bid -
                                                                                    System will auto
                                                                                    bid upto the
                                                                                    amount entered
                                                                                </p>
                                                                                <Bidding
                                                                                    data={
                                                                                        selectedProduct
                                                                                    }
                                                                                    hard="0"
                                                                                    audio={
                                                                                        audio_loc
                                                                                    }
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </>
                                                                )
                                                            ) : null}
                                                        </>
                                                    )}
                                                    {global?.storeConfigration?.qty_input_slider
                                                        ?.value != 1 ? (
                                                        <>
                                                            {selectedProduct.buynow &&
                                                            selectedProduct?.user_id == user?.id ? (
                                                                <p>
                                                                    You cannot buy your own product!
                                                                </p>
                                                            ) : (
                                                                <>
                                                                    {selectedProduct.buynow ? (
                                                                        selectedProduct.wprice >=
                                                                        selectedProduct.bprice ? null : (
                                                                            <>
                                                                                {user?.id ==
                                                                                selectedProduct.user_id ? null : (
                                                                                    <div className="">
                                                                                        <PrimaryButton
                                                                                            onClick={
                                                                                                handleClick
                                                                                            }
                                                                                            disabled={
                                                                                                user?.status ==
                                                                                                'suspended'
                                                                                            }
                                                                                        >
                                                                                            {disabled
                                                                                                ? 'Remove from cart eeeeee'
                                                                                                : `Buy now for ${currencyFormat(
                                                                                                      parseFloat(
                                                                                                          selectedProduct.bprice,
                                                                                                      ).toFixed(
                                                                                                          2,
                                                                                                      ),
                                                                                                  )}`}
                                                                                        </PrimaryButton>
                                                                                    </div>
                                                                                )}
                                                                                <br />
                                                                            </>
                                                                        )
                                                                    ) : null}

                                                                    {global.pluginConfiguration
                                                                        ?.make_an_offer?.enable &&
                                                                    selectedProduct?.make_an_offer_io &&
                                                                    selectedProduct?.buynow &&
                                                                    !selectedProduct?.auction &&
                                                                    selectedProduct?.user_id !=
                                                                        user?.id ? (
                                                                        <div className="row">
                                                                            {mapData(make_an_offer)}
                                                                            <div className="col-sm-6 col-12">
                                                                                <PrimaryButton
                                                                                    onClick={(e) =>
                                                                                        selectedProduct.market_status ==
                                                                                        'open'
                                                                                            ? make_formik.handleSubmit()
                                                                                            : ''
                                                                                    }
                                                                                    disabled={
                                                                                        selectedProduct.market_status ==
                                                                                        'sold'
                                                                                    }
                                                                                >
                                                                                    {selectedProduct.market_status ==
                                                                                    'sold'
                                                                                        ? 'Lot Sold'
                                                                                        : `Submit Offer`}
                                                                                </PrimaryButton>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        ''
                                                                    )}

                                                                    {global.pluginConfiguration
                                                                        ?.make_an_offer?.enable &&
                                                                    selectedProduct?.make_an_offer_io &&
                                                                    selectedProduct?.auction &&
                                                                    !selectedProduct?.buynow &&
                                                                    upcomming &&
                                                                    selectedProduct?.user_id !=
                                                                        user?.id ? (
                                                                        <div className="row">
                                                                            {mapData(make_an_offer)}
                                                                            <div className="col-sm-6 col-12">
                                                                                <PrimaryButton
                                                                                    onClick={(e) =>
                                                                                        selectedProduct.market_status ==
                                                                                        'open'
                                                                                            ? make_formik.handleSubmit()
                                                                                            : ''
                                                                                    }
                                                                                    disabled={
                                                                                        selectedProduct.market_status ==
                                                                                        'sold'
                                                                                    }
                                                                                >
                                                                                    {selectedProduct.market_status ==
                                                                                    'sold'
                                                                                        ? 'Lot Sold'
                                                                                        : `Submit Offer`}
                                                                                </PrimaryButton>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        ''
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {global?.storeConfigration?.qty_input_slider
                                                        ?.value != 1 ? (
                                                        <PrimaryButton
                                                            label="Login to continue"
                                                            btnSize="small"
                                                            onClick={() =>
                                                                handleRedirectInternal(
                                                                    history,
                                                                    'login',
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {global?.pluginConfiguration?.advertisement?.enable == 1 ? (
                                    <div className="siteAds adsProd">
                                        {isMobile
                                            ? prodAds?.mobProdBottom[
                                                  activeProdAdsIndex?.mobProdBottom
                                              ]
                                            : prodAds?.deskProdBottom[
                                                  activeProdAdsIndex?.deskProdBottom
                                              ]}
                                    </div>
                                ) : null}
                            </div>
                            <Bidhistory
                                modaltitle="Bid history"
                                open={Object.keys(historyData).length !== 0}
                                value={historyData}
                                handleClose={() => setHistoryData({})}
                            />
                            {user && global.pluginConfiguration?.messages?.enable == 1 && (
                                <MessagePlugin product={selectedProduct} />
                            )}
                        </div>
                    ) : (
                        <div className="container pt-5">
                            <NoRecordsFound />
                        </div>
                    )}
                </>
            )}
        </>
    )

    return viewPage ? (
        render
    ) : isRRThemeSlidePanel ? (
        <Drawer
            className={
                Object.keys(historyData).length !== 0
                    ? 'rightDrawer productViewDrawer customizCincyPopup'
                    : 'rightDrawer productViewDrawer'
            }
            anchor={'right'}
            open={selectedLot}
            onClose={handleClose}
        >
            {RRThemeRender}
        </Drawer>
    ) : (
        <Drawer
            className={
                Object.keys(historyData).length !== 0
                    ? 'rightDrawer productViewDrawer customizCincyPopup'
                    : 'rightDrawer productViewDrawer'
            }
            anchor={'right'}
            open={selectedLot}
            onClose={handleClose}
        >
            {render}
        </Drawer>
    )
}

export default SlidePanel
